'use client';

import { createContext, useContext } from 'react';

type OverlayPortalContextValue = {
    portalTarget: HTMLElement | null;
    isInsideModal: boolean;
};

export const overlayPortalContextDefaultValue: OverlayPortalContextValue = {
    portalTarget: null,
    isInsideModal: false,
};

export const OverlayPortalContext = createContext<OverlayPortalContextValue>(overlayPortalContextDefaultValue);

export const useOverlayPortalContext = (): OverlayPortalContextValue => useContext(OverlayPortalContext);
